<template>
  <!-- TODO: Replace headerButtons with a button bar component that takes md-buttons as a child (maybe in the future when md-components is a considered project?) -->
  <md-report-layout :header-buttons="headerButtons"
                    :loading="loading"
                    :loading-text="loadingText"
                    ref="reportLayout">

    <template v-slot:header-left>
      <md-date-select :init-start="rangeStart" :init-end="rangeEnd" @change="dateRangeChanged" display-mode="standalone" mode="customRange" />
    </template>

    <template v-slot:employee-list>
      <!--md-date-select :init-start="rangeStart" :init-end="rangeEnd" @change="dateRangeChanged"/-->

      <EmployeeList :loading="loadingEmployees"
                        :employees="employees"
                        :can-select-multiple="true"
                        :init-all-selected="true"
                        @employeeSelected="onEmployeeSelected"
                        style="height: calc(100vh - 400px); margin-bottom: 10px;"/>
    </template>

    <template v-slot:report-settings>
      <ReportConfig :options="reportConfigData" @configChanged="onReportConfigChange"/>
    </template>

    <template v-slot:report-list>
      <ml-report-list :reports="reports"
                      :loading="loadingReports"
                      @deleteReport="openDeleteReportPopup"
                      @downloadReport="downloadReport"
                      @reportClicked="openReport"/>
    </template>

    <template v-slot:button-bar v-if="creatingReport || !canCreateReport">
      <span v-if="creatingReport">
        <i class="fas fa-circle-notch fa-spin"></i>
         {{ $t('report.comp.reportBeingCreated') }}
      </span>
      <span v-else>
        {{ $t('report.comp.includeAtLeastOneAbsenceType') }}
      </span>
    </template>

  </md-report-layout>
</template>

<script>
import moment from 'moment';
import MdReportLayout from '@/components/reportcontext/ReportLayout';
import MdDateSelect from '@/components/uicomponents/md-date-select';
import MlReportList from '@/components/uicomponents/ml-report-list';
import ReportConfig from '@/components/uicomponents/reportconfig';
import EmployeeList from '@/components/uicomponents/employeelist';
import { reportMixin } from '@/components/reportcontext/report-mixin';
import { mapGetters } from "vuex";
import VueEventBus from '../../vue-event-bus';

export default {
  name: 'reportabsencesoverview',
  components: {
    MdReportLayout,
    MdDateSelect,
    MlReportList,
    ReportConfig,
    EmployeeList,
  },
  mixins: [ reportMixin ],
  data() {
    return {
      loadingText: this.$t('report.comp.loadingAbsencesOverview'),
    }
  },
  created: function () {
    console.log("CREATED");
    VueEventBus.$on("JobReportEvent:jobCreated", this.jobCreated);
    VueEventBus.$on("JobReportEvent:jobStarted", this.jobStarted);
    VueEventBus.$on("JobReportEvent:jobEnded", this.jobEnded);
    VueEventBus.$on("JobReportEvent:jobFailed", this.jobFailed);
  },
  beforeDestroy: function () {
    // console.log("BEFORE DESTROY");
    VueEventBus.$off("JobReportEvent:jobCreated", this.jobCreated);
    VueEventBus.$off("JobReportEvent:jobStarted", this.jobStarted);
    VueEventBus.$off("JobReportEvent:jobEnded", this.jobEnded);
    VueEventBus.$off("JobReportEvent:jobFailed", this.jobFailed);
  },
  destroyed: function () {
    // console.log("DESTROYED");
  },
  mounted() {
    if (this.$store.state.jwt !== undefined && this.$store.state.companyId !== undefined) {

      this.refresh();

      // NOTE:
      // demo code for updateReportConfig
      // this.updateReportConfig('test', 1);
      // this.updateReportConfig('testObj', {});
      // this.updateReportConfig(['testObj', 'key'], 1);
      // creates a new deeply nested config entry
      // this.updateReportConfig(['testObj', 'key2', 'newNested', 'newNested2'], 1);
    }
  },
  computed: {
    ...mapGetters(['companyId','companySettings', 'storesSettings']),
    headerButtons() {
      let helperLinks = [];
      let buttons = [
        {
          classes: 'add-employeetype',
          type: 'block gray',
          disabled: false,
          icon: 'fa-th-list',
          click: ($event) => {
          },
          show: true,
          tooltip: this.$t('report.comp.absencesOverview'),
          title: this.$t('report.comp.absencesOverview'),
          helperText: this.$t('report.comp.absencesOverviewDescription'),
          //externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/1134428161"
        },
        {
          type: 'block green',
          disabled: this.creatingReport || !this.canCreateReport,
          icon: this.creatingReport ? 'fa-redo' : 'fa-file-check',
          click: ($event) => {
            this.createReportProxy();
          },
          show: true,
          tooltip: this.$t('report.comp.createReport'),
          title: this.$t('report.comp.createReport'),
        },
      ];
      let state = {
        buttons: buttons,
        helperLinks: helperLinks,
        showListIconAlways: true,
      };

        state.helperLinks = [
            {
                icon: "fa-video",
                title: this.$t('report.comp.watchTrainingVideo'),
                helperText: this.$t('report.comp.watchTrainingVideoHelper'),
                externalUrl: "https://www.youtube.com/watch_popup?v=BePh4xNJvsY",
                externalLabel: this.$t('report.comp.trainingVideoReports'),
                cancelLabel: this.$t('global.ui.close')
            },
            {
                title: this.$t('report.comp.getSupport'),
                helperText: this.$t('report.comp.getSupportHelper'),
                externalUrl: 'https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/15',
                externalLabel: this.$t('export.comp.contactSupport'),
                cancelLabel: this.$t('global.ui.close')
            }
        ];
      return state;
    },

    canCreateReport() {
      // const fileContent = this.reportConfig.fileContent || {};
      // return (fileContent.selectedTypes || []).length > 0;
      return true;
    },
  },
  watch: {
    companyId(newVal, oldVal) {
      console.log("COMPANY ID CHANGED", newVal, oldVal);
      this.refresh(true);
    },
    rangeStart() {
      this.updateReportConfig('reportname', this.getReportName());
    },
  },
  // methods that implement data (BUSINESS) logic. (https://en.wikipedia.org/wiki/Business_logic)
  methods: {
    getReportName() {
        return this.rangeMode === 'monthlyRange'
            ? this.$t('report.comp.absencesOverviewWithMonth', {
                title: this.$t('report.comp.absencesOverview'),
                monthYear: moment(this.rangeStart).format('MMMM YYYY')
            })
            : this.$t('report.comp.absencesOverviewWithRange', {
                title: this.$t('report.comp.absencesOverview'),
                startDate: moment(this.rangeStart).format('DD.MM.YYYY'),
                endDate: moment(this.rangeEnd).format('DD.MM.YYYY')
            });
    },

    async refresh(force = false) {
      this.loading = true;
      this.rangeMode = 'customRange';
      this.updateReportConfig('reportname', this.getReportName());

      try {
        await Promise.all([
          this.$helpers.GetCompanySettings(force),
          this.$helpers.GetStoresSettings(force),
          this.$helpers.GetExportSettingsMap(force),
          this.loadReports('ABSENCESOVERVIEW'),
          this.loadEmployees(true),
        ]);
      } catch (error) {
        console.error(error);
      } finally {
        this.generateReportConfigOpts();

        // console.log(this.getReportConfigValue('reportname'));
        // reportConfig can be loaded after generating the options, as reportConfig does not overwrite the options
        this.reportConfig = this.loadReportConfig();
        this.updateReportConfig('reportname', this.getReportName());

        console.log(this.reports);

        this.loading = false;
      }
    },

    onEmployeeSelected(employee) {
      console.log(employee);
      employee.isSelected = true;
      this.$helpers.info(
          this.$t('report.comp.attention'),
          this.$t('report.comp.cannotDeselectEmployees')
      );
      // this.selectedEmployee = employee.isSelected ? employee : null;
      // No need to update employeeList as the currently selected employee is stored in its own variable
      // this.employeeList = this.employeeList.map(emp => ({ ...emp, selected: emp.id === employee.id }));
    },

    generateReportConfigOpts() {
      let disabled = !this.CheckEnableConfigEdit
      let specialDisabled = !this.CheckEnableConfigSpecialEdit
      const nameSection = this.createReportConfigSection(this.$t('report.comp.documentName'), true, disabled, 'nameSection');
      this.addTextConfigOption(nameSection, 'reportname', this.$t('report.comp.enterDocumentName'), this.getReportName(), true);

      const commentSection = this.createReportConfigSection(this.$t('employee.contract.comment'), false, disabled, 'commentSection');
      this.addTextConfigOption(commentSection, 'reportcomment', this.$t('report.comp.enterComment'));

      const formatSection = this.createReportConfigSection(this.$t('report.comp.fileFormat'), false, disabled, 'formatSection');
      this.addSelectConfigOption(formatSection, 'fileformat', [
        this.addSelectableValue('PDF', 'pdf', true),
        // this.addSelectableValue('CSV', 'csv'),
      ]);

      const storeSection = this.createReportConfigSection('Store', false, disabled, 'storeSection');
      this.addSelectConfigOption(storeSection, 'storeIds', [
        this.addSelectableValue(this.$t('report.comp.allStores'),
          this.storesSettings.data.map(store => this.addSelectableValue(store.name, store.id)),
          this.storesSettings.data.map(store => store.id),
          'selectedStores')
      ], true);

      let mdEmployeeAvailabilityTypes = this.$helpers.GetMdEmployeeAvailabilityTypes();
      let mdEmployeeAvailabilitySubTypes = this.$helpers.GetMdEmployeeAvailabilitySubTypes();

      const contentSection = this.createReportConfigSection(this.$t('report.comp.documentContent'), false, disabled, 'contentSection');
      this.addSelectConfigOption(contentSection, 'sumsOnly', [
        this.addSelectableValue('Nur Summen', true),
        this.addSelectableValue('Alle Einträge', false, true),
      ]);
      this.addSelectConfigOption(contentSection, 'includeUnconfirmed', [
        this.addSelectableValue('Nicht genehmigte inkludieren', true),
        this.addSelectableValue('Nicht genehmigte ignorieren', false, true),
      ]);

      const absenceSection = this.createReportConfigSection(this.$t('report.comp.absenceContent'), false, disabled, 'absenceSection');
      this.addSelectConfigOption(absenceSection, 'vacation', [
        this.addSelectableValue(mdEmployeeAvailabilityTypes.find(type => type.value === 1).label, mdEmployeeAvailabilityTypes.find(type => type.value === 1).value, true),
      ], true);
      this.addSelectConfigOption(absenceSection, 'sickness', [
        this.addSelectableValue(mdEmployeeAvailabilityTypes.find(type => type.value === 2).label,
          mdEmployeeAvailabilitySubTypes.filter(subtype => subtype.parentType === 2).map(subtype => this.addSelectableValue(subtype.label, subtype.value)),
          mdEmployeeAvailabilitySubTypes.filter(subtype => subtype.parentType === 2).map(subtype => subtype.value),
          'selectedSicknessSubTypes')
      ], true);
      this.addSelectConfigOption(absenceSection, 'holidaycompensation', [
        this.addSelectableValue(mdEmployeeAvailabilityTypes.find(type => type.value === 3).label, mdEmployeeAvailabilityTypes.find(type => type.value === 3).value, true),
      ], true);
      this.addSelectConfigOption(absenceSection, 'other', [
        this.addSelectableValue(mdEmployeeAvailabilityTypes.find(type => type.value === 4).label,
          mdEmployeeAvailabilitySubTypes.filter(subtype => subtype.parentType === 4).map(subtype => this.addSelectableValue(subtype.label, subtype.value)),
          mdEmployeeAvailabilitySubTypes.filter(subtype => subtype.parentType === 4).map(subtype => subtype.value),
          'selectedOtherSubTypes')
      ], true);
      this.addSelectConfigOption(absenceSection, 'personal', [
        this.addSelectableValue(mdEmployeeAvailabilityTypes.find(type => type.value === 6).label,
          mdEmployeeAvailabilitySubTypes.filter(subtype => subtype.parentType === 6).map(subtype => this.addSelectableValue(subtype.label, subtype.value)),
          mdEmployeeAvailabilitySubTypes.filter(subtype => subtype.parentType === 6).map(subtype => subtype.value),
          'selectedPersonalSubTypes')
      ], true);
      this.addSelectConfigOption(absenceSection, 'training', [
        this.addSelectableValue(mdEmployeeAvailabilityTypes.find(type => type.value === 7).label, mdEmployeeAvailabilityTypes.find(type => type.value === 7).value, true),
      ], true);
      this.addSelectConfigOption(absenceSection, 'continuedpay', [
        this.addSelectableValue(mdEmployeeAvailabilityTypes.find(type => type.value === 8).label,
          mdEmployeeAvailabilitySubTypes.filter(subtype => subtype.parentType === 8).map(subtype => this.addSelectableValue(subtype.label, subtype.value)),
          mdEmployeeAvailabilitySubTypes.filter(subtype => subtype.parentType === 8).map(subtype => subtype.value),
          'selectedContinuedPaySubTypes')
      ], true);

      const localeSection = this.createReportConfigSection(this.$t('report.comp.locale'), false, disabled, 'localeSection');
      this.addLanguageSelectConfigOption(localeSection, 'settingLocale', disabled);

      const headerFormatSection = this.createReportConfigSection(  this.$t('report.comp.header'), false, specialDisabled, 'headerFormatSection');
      this.addSelectConfigOption(headerFormatSection, 'settingDateFormat', [
        this.addSelectableValue('DD.MM.YYYY', 'DD.MM.YYYY', true),
        this.addSelectableValue('YYYY-MM-DD', 'YYYY-MM-DD'),
      ]);
      this.addSelectConfigOption(headerFormatSection, 'headerShowQr', [
        this.addSelectableValue(this.$t('report.comp.showQrCode'), true, true),
        this.addSelectableValue(this.$t('report.comp.hideQrCode'), false),
      ]);

    },

    async createReportProxy() {
      if (this.rangeMode === 'customRange') {
        if (this.rangeStart > this.rangeEnd) {
          this.$helpers.error(this.$t('employee.data.error'), this.$t('report.comp.startBeforeEnd'));
          return;
        }
      }
      await this.generateReport();
    },

    async generateReport() {
      this.creatingReport = true;

      const employeeIds = this.selectedEmployeeIds;

      const dateFormats = {
        'DD.MM.YYYY': 'dmY',
        'YYYY-MM-DD': 'Ymd',
      };
      const dateFormat = dateFormats[this.reportConfig.settingDateFormat] || 'dmY';

      const hourFormats = {
        '3': '3',
        '2': '2',
        'Hm': 'Hm',
      };
      const hourFormat = hourFormats[this.reportConfig.settingHourFormat] || 'Hm';

      let locale = this.reportConfig.settingLocale || 'de';
      if (locale === 'current') {
        locale = this.$i18n.locale;
      }

      const name = this.reportConfig.reportname;
      const comment = this.reportConfig.reportcomment;
      const config = {
        'headerDateFormat': dateFormat,
        'hourFormat': hourFormat,
        'storeIds': this.reportConfig.storeIds.selectedStores || [],
        'sumsOnly': this.reportConfig.sumsOnly,
        'includeUnconfirmed': this.reportConfig.includeUnconfirmed,
        'selectedTypes': {
          ...this.reportConfig.vacation,
          ...this.reportConfig.holidaycompensation,
          ...this.reportConfig.training,
        },
        'selectedSubTypes': {
          2: this.reportConfig.sickness.selectedSicknessSubTypes || [],
          4: this.reportConfig.other.selectedOtherSubTypes || [],
          6: this.reportConfig.personal.selectedPersonalSubTypes || [],
          8: this.reportConfig.continuedpay.selectedContinuedPaySubTypes || [],
        },
        'headerShowQr': this.reportConfig.headerShowQr,
        'documentComment': comment,
        'headerLogo': 'ml',
        'fileformat': this.reportConfig.fileformat ?? 'pdf',
        'language': locale,
      };

      if (this.rangeMode === 'customRange') {


        config.fromDate = this.rangeStart.format();
        config.toDate = this.rangeEnd.format();

      }

      // console.log("CREATE REPORT", name, comment, config);
      await this.createReport('ABSENCESOVERVIEW', name, comment ? comment : "", config);
    },

    jobCreated: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB CREATED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 50);
    },
    jobStarted: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB STARTED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 100);
    },
    jobEnded: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB ENDED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 200);
    },
    jobFailed: function () {
      let view = this;
      setTimeout(function () {
        console.log("JOB FAILED EVENT GOT TRIGGERED");
        view.reloadDocuments();
      }, 200);
    },
    reloadDocuments: function () {
      this.loadReports('ABSENCESOVERVIEW');
    }

  },
}
</script>

<style scoped>
>>>.config-entry>.body.entry-expanded {
  max-height: 100% !important;
}
</style>
